import { type McpServerWithRelations } from "@/lib/mcp/types";

/**
 * Checks if two account IDs are different (both must be truthy for this to return true)
 */
const normalizeAccountId = (
  accountId: number | string | undefined | null,
): string | null => {
  if (accountId == null) {
    return null;
  }

  return String(accountId);
};

export const isDifferentAccount = (
  accountId1: number | string | undefined | null,
  accountId2: number | string | undefined | null,
): boolean => {
  const normalizedAccountId1 = normalizeAccountId(accountId1);
  const normalizedAccountId2 = normalizeAccountId(accountId2);

  return Boolean(
    normalizedAccountId1 &&
    normalizedAccountId2 &&
    normalizedAccountId1 !== normalizedAccountId2,
  );
};

/**
 * Checks if a server is account-agnostic and belongs to a different account than the current user's account
 */
export const isAccountAgnosticFromDifferentAccount = (
  server: McpServerWithRelations,
  currentAccountId: number | string | undefined | null,
): boolean => {
  const isAccountAgnostic =
    server.McpServerOauthConnection?.[0]?.isAccountAgnostic ?? false;
  const serverAccountId = server.ownerMembership?.zapierAccount?.id;

  return (
    isAccountAgnostic && isDifferentAccount(serverAccountId, currentAccountId)
  );
};
